<template>
  <!-- 合同范本内容页 -->
  <div id="conmodet">
    <div class="w12 between">
      <div class="left">
        <cmdetzw class="comi" />
      </div>
      <div class="right">
        <cdethttj class="riitm" :ismore="true" @rigclick="clmore" />
        <cdethttj class="riitm mt30" httle="推荐合同" @rigclick="clmore" />
        <cdethttj class="riitm mt30" httle="最新合同" @rigclick="clmore" />
        <downrank class="downrank riitm mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import cmdetzw from "./child/cmdetzw";
import cdethttj from "./child/cdethttj";
import downrank from "views/contractmodel/components/htrank";
export default {
  name: "conmodet",
  components: {
    cmdetzw,
    cdethttj,
    downrank,
  },
  methods: {
    clmore() {
      console.log("点击了右侧按钮");
    },
  },
};
</script>

<style lang="scss" scoped>
#conmodet {
  background: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;

    .left {
      .comi {
        width: 100%;
      }
      width: 856px;
    }
    .right {
      .riitm {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      width: 314px;
      
    }
  }
}
</style>